export const en = {
  nav: {
    charts: "Natal Charts",
    natalChart: "Natal Chart",
    horoscope: "Horoscopes",
    mysteries: "Mysteries",
    oracle: "Consult Oracle",
    auth: "Sign In",
    compatibility: "Compatibility",
    calendar: "Calendar of Power",
    profile: "Dashboard",
    back: "Back"
  },
  auth: {
    title: "Celestial Entry",
    subtitle: "Rejoin your cosmic journey or begin a new path.",
    login: "Sign In",
    register: "Create Account",
    email: "Email Address",
    password: "Password",
    vk: "Continue with VK",
    yandex: "Continue with Yandex",
    google: "Continue with Google",
    terms: "I agree to the Terms of Cosmic Service",
    noAccount: "New seeker?",
    hasAccount: "Already a member?",
    forgot: "Forgot password?",
    success: {
      signedIn: "Signed in",
      signedUp: "Signed up",
      signedOut: "Signed out",
      providerLinked: "Account linked",
      providerUnlinked: "Account unlinked",
    },
    welcome: "Welcome!",
    welcomeBack: "Welcome back!",
    linkAccount: "linked to your account",
    passwordResetEmailSent: "Email sent",
    passwordResetEmailDescription: "Check your email to reset password",
    resetPassword: "Reset password",
    resetPasswordDescription: "Enter a new password for your account",
    newPassword: "New password",
    confirmPassword: "Confirm password",
    verifyingCode: "Verifying reset link",
    verifying: "Verifying",
    passwordResetSuccess: "Password updated",
    passwordResetError: "Reset password error",
    passwordResetSuccessDescription: "Password updated. You will be redirected to the home page.",
    passwordResetErrorDescription: "The link is invalid or expired. Please request a new one.",
    goToHome: "Go to home",
    passwordSetupEmailSent: "Email sent",
    passwordSetupEmailDescription: "Check your email to setup password",
    signOut: "Sign Out",
    errors: {
      unknownError: "An error occurred",
      userNotFound: "User not found",
      wrongPassword: "Wrong password",
      emailInUse: "Email already in use",
      weakPassword: "Password too weak",
      invalidEmail: "Invalid email",
      tooManyRequests: "Too many requests",
      networkError: "Network error",
      popupClosed: "Auth popup closed",
      providerAlreadyLinked: "Provider already linked",
      credentialInUse: "Credential already in use",
      redirectUriMismatch: "OAuth configuration error",
      accountExistsUseSocial: "Account exists. Use social networks to sign in",
      passwordMismatch: "Passwords do not match",
    },
  },
  hero: {
    badge: "Written in the Stars since 2025",
    title1: "Decode Your",
    titleAccent: "Celestial",
    title2: "Blueprint.",
    description: "Unlock the ancient wisdom of the cosmos. Our advanced algorithms merge sacred geometry with planetary alignments to reveal your soul's true purpose.",
    ctaPrimary: "Generate Chart",
    ctaSecondary: "Learn the Path",
    moonPhase: "Current Phase: Waning Moon"
  },
  features: {
    header: "Cosmic Tools",
    subheader: "Tools designed to bridge the gap between the mundane and the divine.",
    items: [
      { title: "Natal Mapping", desc: "A precise snapshot of the heavens at the exact moment of your arrival." },
      { title: "Synastry", desc: "Deep compatibility analysis through the lens of composite charts." },
      { title: "Calendar of Power", desc: "Find the perfect time for action." },
      { title: "Transits 2026", desc: "Personal transits forecast for 2026 with predictions and recommendations.", premium: true },
      { title: "Lunar Calendar", desc: "Find the best days for haircuts according to the lunar calendar." },
      { title: "Pregnancy Planning", desc: "Calculate favorable conception dates with astrological analysis.", premium: true }
    ]
  },
  calendar: {
    title: "Calendar of Power",
    subtitle: "Find the perfect timing for your intentions.",
    inputPlaceholder: "E.g.: sign a contract or start a journey",
    button: "Seek the Timing",
    score: "Power Score",
    description: "Cosmic Advice",
    bestDays: "Best Days",
    start_date: "Start Date",
    end_date: "End Date",
    optional: "optional",
    details: "Day Details",
    loading: {
      analyzing: "Analyzing goal...",
      sending: "Sending request...",
      processing: "Processing results...",
      done: "Done!"
    },
    noData: "No cosmic data available for this date.",
    avoid: "Avoid",
    avoidDesc: "Periods to avoid",
    levelA: "Level A (Best)",
    levelB: "Level B",
    levelC: "Level C",
    levelD: "Level D",
    insights: "Key Insights",
    next30Days: "Next 30 Days",
    haircut: {
      title: "Lunar Haircut Calendar",
      location: "Location",
      dateSelector: "Select Date",
      autoLocation: "Auto",
      freeBadge: "Free",
      growth: "Growth",
      thickness: "Thickness",
      health: "Health",
      auspicious: "Auspicious",
      neutral: "Neutral",
      inauspicious: "Inauspicious"
    }
  },
  astroCareer: {
    title: "Astro Career Guide",
    subtitle: "Career orientation from your natal chart: strengths, directions, and concrete steps.",
    sideNote: "Talent map",
    formTitle: "Input data",
    personLabel: "Chart owner",
    personPlaceholder: "Select a person",
    traitsLabel: "Focus traits",
    traitsHint: "Optional: affects accents and examples. You can leave it empty.",
    formHint: "Based on the natal chart: exact birth time and location matter most.",
    loadingMessage: "Building a career profile from the natal chart...",
    generateButton: "Generate guidance",
    generating: "Generating...",
    signalTitle: "Career signal",
    confidence: "Confidence",
    readableTitle: "Ready-to-paste text",
    readableHint: "Human-readable block ready for UI insertion.",
    readablePlaceholder: "The ready-to-paste text will appear here.",
    cardTitle: "Short card",
    cardPlaceholder: "Generate the analysis to see the short card.",
    cardWhyPlaceholder: "Three key factors will show up here.",
    scoreLabel: "Score",
    professions: "Professions",
    actionSteps: "Action steps",
    scoreFactors: "Score factors",
    topPlaceholder: "Run the analysis to see the top directions.",
    explainabilityPlaceholder: "Explainability will appear after generation.",
    notesPlaceholder: "No model notes yet.",
    widgetTitle: "Career",
    lockBadge: "Soon",
    lockNote: "New feature for Student Day",
    tabs: {
      top: "Top 3",
      explainability: "Explainability",
      notes: "Notes",
    },
    categories: {
      leadership: "Leadership",
      creative: "Creative",
      analytical: "Analytical",
      communication: "Communication",
      care: "Care",
      business: "Business",
    },
    categoriesHints: {
      leadership: "Management, strategy, influence",
      creative: "Design, media, creative industries",
      analytical: "Data, tech, research",
      communication: "Marketing, sales, negotiation",
      care: "Helping professions, mentoring",
      business: "Entrepreneurship, finance, growth",
    },
  },
  cta: {
    title: "Fate Awaits",
    description: "Join a collective of over 100,000 seekers navigating the stars. Your destiny is not a destination, but a frequency.",
    button: "Enter the Sanctuary"
  },
  persona: {
    title: "Create Persona",
    subtitle: "Enter the details of your arrival to map your cosmic blueprint.",
    name: "Full Name",
    birthDate: "Date of Birth",
    birthTime: "Time of Birth",
    birthPlace: "Place of Birth",
    gender: "Gender",
    genders: {
      male: "Male",
      female: "Female",
      other: "Other"
    },
    submit: "Create Persona",
    placeholders: {
      name: "Enter name",
      place: "City, Country",
      time: "00:00"
    }
  },
  traits: {
    characteristicsTitle: "Select characteristics (up to 3)",
    talentsTitle: "Select talents",
    prioritiesTitle: "Select priority (one)",
    notesTitle: "Additional notes",
    notesSubtitle: "Describe additional wishes or important points for the future child",
    notesPlaceholder: "Enter your notes...",
    birthLocationTitle: "Planned birth location",
    birthLocationSubtitle: "Specify the place where the child is planned to be born. This is important for accurate natal chart calculation.",
    plannedBirthPlace: "Birth place",
    parentsSubtitle: "Parent data is used for compatibility analysis",
    parent1Title: "Parent 1",
    parent2Title: "Parent 2",
    parentsData: "Parents data",
    birthDate: "Birth date",
    birthTime: "Birth time",
    birthPlace: "Birth place",
    optional: "optional",
    summaryTitle: "Summary",
    list: {
      leadership: "Leadership",
      creativity: "Creativity",
      empathy: "Empathy",
      intelligence: "Intelligence",
      communication: "Communication",
      discipline: "Discipline",
      intuition: "Intuition",
      energy: "Energy",
      kindness: "Kindness",
      confidence: "Confidence",
      patience: "Patience",
      curiosity: "Curiosity",
    },
    talents: {
      music: "Music",
      art: "Art",
      sports: "Sports",
      academic: "Academic",
      social: "Social",
      technical: "Technical",
    },
    priorities: {
      family: "Family",
      career: "Career",
      wealth: "Wealth",
      health: "Health",
      education: "Education",
      relationships: "Relationships",
    },
  },
  stepper: {
    back: "Back",
    next: "Next",
    stepProgress: "Step {{current}} of {{total}}",
  },
  footer: {
    tagline: "The stars incline, they do not bind.",
    links: ["Oracle", "Archive", "Contact"],
    copy: "© 2025 astrobaby"
  },
  dashboard: {
    badge: "Dashboard",
    welcome: "Welcome, {{name}}!",
    subtitle: "Your personal cosmic laboratory. Explore the stars, learn about yourself and loved ones.",
    createProfile: "Create your profile",
    createProfileDescription: "We need your birth data for personalized forecasts and \"My Day\".",
    createProfileButton: "Create profile",
    cosmicTools: "Cosmic Tools",
    quickOverview: "Actions",
    sunSign: "Sun Sign",
    profile: "Profile",
    birthDate: "Birth Date",
    mySubscription: "My Subscription",
    subscriptionActive: "Active",
    subscriptionInactive: "No Subscription",
    subscribe: "Subscribe",
    features: {
      natalChart: {
        title: "Natal Charts",
        description: "Manage profiles and natal charts",
        myChartButton: "My Natal Chart",
      },
      compatibility: {
        title: "Compatibility",
        description: "Analysis of cosmic connection with a partner",
      },
      astroCareer: {
        title: "Astro Career Guide",
        description: "Career orientation based on natal chart strengths",
      },
      lifeTimeline: {
        title: "Life Timeline",
        description: "Personal timeline of likely themes and peaks",
      },
      calendar: {
        title: "Calendar of Power",
        description: "Find the perfect time for action",
      },
      transits2026: {
        title: "Transits 2026",
        description: "Personal transits forecast for 2026",
      },
      haircutCalendar: {
        title: "Lunar Calendar",
        description: "Find the best days for haircuts according to the lunar calendar",
      },
      pregnancyPlanning: {
        title: "Pregnancy Planning",
        description: "Calculate favorable conception dates with astrological analysis",
      },
      people: {
        title: "People",
        description: "Manage profiles of loved ones and create natal charts",
      },
    },
    footer: "The stars incline, they do not bind",
    calculationsHistory: {
      title: "Cosmic Chronicles",
      view: "Open",
    },
  },
  calculationsHistory: {
    badge: "Archive",
    title: "Cosmic Chronicles",
    subtitle: "History of all your astrological calculations",
    view: "View",
    partner1: "Partner 1",
    partner2: "Partner 2",
    untitled: "Untitled",
    types: {
      elections: "Calendar of Power",
      compatibility: "Compatibility",
      conception: "Conception Planning",
      lifeTimeline: "Life Timeline",
      astroCareer: "Astro Career Guide",
      unknown: "Calculation",
    },
    elections: {
      windows: "Luck windows: {{count}}",
      stops: "Periods to avoid: {{count}}",
    },
    compatibility: {
      score: "Compatibility: {{score}}%",
    },
    conception: {
      dates: "Favorable dates: {{count}}",
      titleWithDates: "Conception Planning • {{count}} dates",
      titleWithDate: "Conception Planning • {{date}}",
    },
    table: {
      type: "Type",
      title: "Title",
      details: "Details",
      date: "Date",
      actions: "Actions",
    },
    empty: {
      title: "No calculations yet",
      description: "Create your first calculation to see it here",
      action: "Go to tools",
    },
  },
  myDay: {
    title: "My Day",
    subtitle: "Personal astrological forecasts",
    loading: "The astrologer is calculating your day...",
    affirmationTitle: "Affirmation of the day",
    forecastsTitle: "Forecasts for today",
    noContent: "Content for today is not ready",
    noContentDescription: "It will be generated automatically",
    regenerateContent: "Get content",
    regenerating: "Generating...",
    updateContent: "Update content",
    updating: "Updating...",
    subscribeRequired: "Subscription required for personal forecasts",
    selectPersonRequired: "Select \"this is me\"",
    selectPersonDescription: "Select a person for personalized forecasts",
    goToPeople: "Go to people",
    subscribeButton: "Subscribe",
    contentUpdated: "Content successfully updated",
    updateError: "Failed to update content",
    loadError: "Failed to load content",
    adviceTitle: "Daily advice",
    showAll: "Show all categories",
    collapse: "Collapse",
    outOf: "out of",
    categories: {
      love: "Love",
      career: "Career",
      social: "Social",
      energy: "Energy",
      intuition: "Intuition",
      health: "Health",
      finance: "Finance",
      creativity: "Creativity",
    },
  },
  onboarding: {
    title: "Profile Creation",
    steps: {
      name: {
        title: "Name",
        description: "How should we address you?",
      },
      birthDate: {
        title: "Birth Date",
        description: "When did you come into this world?",
      },
      birthTime: {
        title: "Birth Time",
        description: "Do you know the exact time?",
        descriptionRequired: "We need your birth time for accurate forecasts",
      },
      birthDateTime: {
        title: "Date & Time of Birth",
        description: "Exact data is needed to calculate your chart",
      },
      birthPlace: {
        title: "Birth Place",
        description: "Where were you born?",
      },
      success: {
        title: "Done!",
        description: "Your cosmic profile is created",
      },
    },
    form: {
      nameLabel: "Your name",
      namePlaceholder: "Enter name",
      genderLabel: "Gender",
      birthDateLabel: "Birth date",
      birthDateHint: "This will help calculate your natal chart",
      birthTimeLabel: "Birth time (if known)",
      birthTimeLabelRequired: "Birth time",
      birthTimeHint: "Exact time determines ascendant and houses. Skip if unknown.",
      birthTimeHintRequired: "Exact time is needed to calculate your ascendant and chart houses.",
      birthPlaceLabel: "Birth place",
      birthPlacePlaceholder: "City, Country",
      birthPlaceHint: "Birth place affects house positions in the chart",
    },
    gender: {
      male: "Male",
      female: "Female",
      other: "Other",
    },
    buttons: {
      back: "Back",
      next: "Next",
      skip: "Skip",
      createProfile: "Create profile",
      saving: "Saving...",
      goToDashboard: "Go to dashboard",
    },
    success: {
      title: "Welcome, {{name}}!",
      description: "Your cosmic profile is created. Now you can receive personalized forecasts.",
    },
    skipLink: "Skip and set up later",
    profileCreated: "Profile created!",
    errorCreating: "Error creating profile",
    alreadyHasProfile: "You already have a profile",
  },
  location: {
    placeholder: "Enter city or place",
  },
  people: {
    form: {
      name: "Name",
      nameRequired: "Name is required",
      namePlaceholder: "Enter name",
      birthDate: "Birth Date",
      birthDateRequired: "Birth date is required",
      birthTime: "Birth Time",
      birthPlace: "Birth Place",
      birthPlaceRequired: "Birth place is required",
      birthPlaceSelect: "Select place from the list",
      addPerson: "Add Person",
      addPersonDescription: "Enter data to create a new person",
      saving: "Saving...",
      add: "Add",
    },
    gender: {
      male: "Male",
      female: "Female",
      other: "Other",
    },
    selector: {
      label: "Select person",
      placeholder: "Select from list...",
      noAvailable: "No people available",
      createNew: "Create New",
      selectExisting: "Select existing",
      clear: "Clear",
    },
    relationship: {
      self: "Me",
      partner: "Partner",
      child: "Child",
      parent: "Parent",
      friend: "Friend",
      other: "Other",
    },
  },
  zodiac: {
    aries: "Aries",
    taurus: "Taurus",
    gemini: "Gemini",
    cancer: "Cancer",
    leo: "Leo",
    virgo: "Virgo",
    libra: "Libra",
    scorpio: "Scorpio",
    sagittarius: "Sagittarius",
    capricorn: "Capricorn",
    aquarius: "Aquarius",
    pisces: "Pisces",
  },
  common: {
    loading: "Loading...",
    error: "Error",
    save: "Save",
    cancel: "Cancel",
    open: "Open",
  },
  subscription: {
    title: "Subscription",
    premium: "Premium",
    choosePlan: "Choose Plan",
    monthly: "Monthly",
    yearly: "Yearly",
    perMonth: "/month",
    perYear: "/year",
    savings: "Save",
    subscribe: "Subscribe",
    features: {
      title: "What's included",
      natalChart: "Full natal chart",
      compatibility: "Partner compatibility",
      calendar: "Calendar of Power",
      forecasts: "Personal forecasts",
      interpretations: "Extended interpretations",
    },
    paywall: {
      title: "Available with subscription",
      description: "Subscribe to get full access to this feature",
      subscribeButton: "Subscribe",
      priceFrom: "From 499 ₽/month",
      cancelAnytime: "Cancel anytime",
      unlockPremium: "Unlock Premium",
      unlockCompatibility: "Unlock Compatibility",
      unlockCalendar: "Unlock Calendar of Power",
      compatibilityAvailable: "Compatibility available with subscription",
      compatibilityDescription: "Subscribe to Premium for partner compatibility analysis",
      calendarAvailable: "Calendar available with subscription",
      calendarDescription: "Subscribe to Premium for personalized Calendar of Power",
      chartDescription: "Get access to extended natal chart analysis",
      sectionLocked: "Section \"{{section}}\" is available with Premium subscription",
      starsInfluence: "Discover how stars influence your relationships",
      findBestMoments: "Find the best moments for important decisions",
      planetDescriptions: "Subscribe to get detailed descriptions of all planets",
      planetDescriptionsTitle: "Planet Descriptions",
      aspectsDescriptions: "Subscribe to see all aspects and their descriptions",
      aspectsDescriptionsTitle: "Other Aspects",
      transits2026Description: "Subscribe to Premium to get your personal transits forecast for 2026",
      transits2026Title: "Transits 2026 Available with Subscription",
      pregnancyPlanningDescription: "This feature is available with a subscription only. Get full access to favorable conception dates calculation, parental compatibility analysis and extended interpretations.",
      pregnancyPlanningPrice: "499₽/month or 4990₽/year",
    },
    success: {
      title: "Payment successful!",
      premiumActivated: "Premium activated",
      description: "You now have access to all premium features of AstroBaby",
      goToApp: "Go to app",
      redirecting: "Redirecting in",
    },
    payment: {
      title: "Subscription payment",
      securePayment: "Secure payment via CloudPayments",
      cards: "Visa, Mastercard, MIR, SBP",
      instantConfirmation: "Instant confirmation",
    },
  },
  chart: {
    tabs: {
      personality: "Personality & Destiny",
      love: "Love & Relationships",
      career: "Career & Money",
      "light-dark": "Light & Shadow",
      children: "Child Astrology",
      pro: "PRO"
    },
    viewChart: "View Chart",
    closeChart: "Back to Reading",
    natalBlueprint: "Natal Blueprint",
    celestialProjection: "Celestial Projection",
    sacredMapFor: "Sacred Map for {{name}}",
    aligningAstralVectors: "Aligning Astral Vectors...",
    starsRevealing: "The stars are revealing your {{section}}. This knowledge is preparing to manifest.",
    planetAspects: "Planet Aspects",
    planetAspectsDesc: "Professional analysis of aspects between planets in your natal chart.",
    horoscopeHouses: "Horoscope Houses",
    horoscopeHousesDesc: "Detailed breakdown of planet positions in horoscope houses.",
    sunInSign: "Sun in {{sign}}",
    ascendantInSign: "Ascendant in {{sign}}",
    moonInSign: "Moon in {{sign}}",
    reset: "Reset",
    born: "Born {{date}}, {{time}} • {{place}}",
    calculatingChart: "Calculating chart...",
  },
  compatibility: {
    title: "Cosmic Compatibility",
    subtitle: "Discover how your energies intertwine with another soul.",
    partnersCompatibility: "Partner Compatibility",
    discoverInfluence: "Discover how the stars influence your connection and unlock relationship potential",
    person1: "First Seeker",
    person2: "Second Seeker",
    type: "Connection Type",
    types: {
      love: "Love & Romance",
      business: "Business & Career",
      friendship: "Friendship",
      family: "Family & Roots"
    },
    calculate: "Align Energies",
    result: {
      score: "Alignment Score",
      strengths: "Cosmic Strengths",
      weaknesses: "Celestial Challenges",
      periods: "Significant Periods",
      divineAlignment: "Divine alignment in aspect {{num}}",
      karmicLesson: "Karmic lesson in field {{num}}",
    }
  },
  settings: {
    title: "Settings",
    description: "Manage your profile and subscription",
    keywords: "settings, profile, subscription, management",
    badge: "Settings",
    subtitle: "Manage your profile and subscription",
    profile: {
      title: "Profile",
      description: "Your account information",
      email: "Email",
      displayName: "Display Name",
      linkedAccounts: "Linked Accounts",
    },
    subscription: {
      title: "Subscription",
      description: "Manage your subscription",
      status: {
        label: "Status",
        active: "Active",
        cancelled: "Cancelled",
        expired: "Expired",
      },
      currentPeriod: "Current Period",
      nextBilling: "Next Billing",
      amount: "Amount",
      noSubscription: "You don't have an active subscription",
      subscribeButton: "Subscribe",
      manage: "Manage",
      cancelButton: "Cancel Subscription",
      cancelConfirm: "Are you sure you want to cancel your subscription? It will remain active until the end of the paid period.",
      cancelYes: "Yes, Cancel",
      cancelNo: "No",
      cancelled: "Subscription successfully cancelled",
      cancelError: "Error cancelling subscription",
      unknownError: "An unknown error occurred",
      changeMe: {
        title: "Change «Me» Profile",
        description: "Select a new profile for transits and forecasts calculation",
        selectPerson: "Select profile",
        currentPerson: "Current «Me» profile",
        changeButton: "Change",
        changing: "Changing...",
        changed: "«Me» profile successfully changed",
        changeError: "Error changing profile",
        limitReached: "Changing «Me» profile is available no more than once a month",
        daysRemaining: "Next change available in",
        recalculationNote: "After change, transits 2026 and «My Day» will be recalculated",
      },
    },
    actions: {
      signOut: "Sign Out",
    },
  },
};
